import { Step } from '../stepper';

export const marginLines = (items: Step[], index: number) => {
  const isCurrentStepSubStep = items[index]?.isSubStep;
  const isNextStepSubStep = items[index + 1]?.isSubStep;

  if (!isCurrentStepSubStep && isNextStepSubStep) {
    return '24px';
  } else if (isCurrentStepSubStep && !isNextStepSubStep) {
    return '10px';
  } else if (isCurrentStepSubStep) {
    return 1.75;
  } else {
    return 2.25;
  }
};
